import { gql } from '@apollo/client';

export const updateMapSystemSettingsMutation =  gql`
    mutation updateMapSystemSettingsMutation($settings: JSON) {
        result: updateSystemSettings(section: map, settings: $settings)
    }
`;

export const loadMapSystemSettingsQuery =  gql`
    query loadMapSystemSettings {
        result: systemSettings(section: map)
    }
`;